import React from "react";
import EmailFooter from "components/email-template/EmailFooter";
import EmailHeader from "components/email-template/EmailHeader";
import { EmailContentComponent } from "components/email-template/types/EmailContent.interface";
import { Box } from "@chakra-ui/react";

const EmailPreview: React.FC<{
	children: EmailContentComponent;
}> = ({ children }) => {
	return (
		<div
			style={{
				maxWidth: "664px",
				margin: "0 auto",
				position: "relative",
				height: "auto",
			}}
		>
			<Box
				borderRadius="sm"
				boxShadow="lg"
				borderWidth={1}
			>
				{children}
				<EmailFooter />
			</Box>
		</div>
	);
};

export default EmailPreview;
